import store from '@/store';

export default class SuccessComponent {
	public get campaignStartDate(): string {
		return store.getters.campaignStartDate();
	}
}
